/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-01-07 20:27:00
 * @LastEditTime: 2023-02-14 11:17:29
 * @FilePath: /client-h5-v2/src/common-ts/resolveButton.ts
 */
import store from '@/store/index'
import params from '@/common-ts/params'
import { apiGetDialogPullMessageTestNow } from '@/apis/dialog/pullMessageTestNow'
import { apiGetDialogChat } from '@/apis/dialog/chat'
import { register } from '@/common-ts/message'

// button 类型定义
interface Button {
  buttonType: string,
  buttonUsage: string,
  content: string,
  innerValue: string | null,
  url: string | null,
  imgPath: string,
  iconCode?: string | null,
  surveyContent?: string | null
}
// 请求计数
let pullMessageCount = 0

/**
 * @description: device help test_now 按钮处理程序
 * @param {type}
 */
export const testNow = (buttonData: Button) => {
  // 是否为test now 或者 try again按钮
  const isTestNow = buttonData.buttonType === 'test_now' || buttonData.buttonType === 'try_again'

  // 对所有的button url字段有值做跳转操作 无值做用户消息发送
  if (buttonData.url) {
    if (isTestNow) {
      window.open(buttonData.url + '?serviceId=' + store.getters['session/serviceId'] + '&turnId=' + store.getters['session/turnId'])
    } else {
      window.open(buttonData.url)
    }
  }

  // 如果是test now按钮
  if (isTestNow && buttonData.url !== '' && buttonData.url !== null) {
    // 获取test now 轮询接口参数
    const testNowParams = params.getTestNowPullMessageParams()
    const index = buttonData.url.indexOf('single/')
    const testId = buttonData.url.substring(index + 7) // 获取item.url （index + 7）下标后得所有字符串
    testNowParams.buttonType = buttonData.buttonType
    testNowParams.buttonUsage = buttonData.buttonUsage
    testNowParams.value = buttonData.content
    testNowParams.testId = testId
    // 获取test now 超时参数
    const testNowTimeOutParams = params.getTestNowTimeoutParams(buttonData)
    // 重置计数为0
    pullMessageCount = 0
    // 发起拉取消息请求
    setTimeout(() => {
      pullMessageRequest({pullParams: testNowParams, timeoutParams: testNowTimeOutParams})
    }, 500)
    return false
  }
}

/**
* @description 定时调取拉取消息方法
* @param {Object} value 事件
*/
let testNowTimer:any = null
const repeatRequestTimer = (value:any) => {
  testNowTimer = setTimeout(() => {
    pullMessageRequest(value)
  }, 5000)
}

/**
   * @description 拉取test now消息
   * @param {pullParams: testNowParams, timeoutParams: testNowTimeOutParams}
   */
const pullMessageRequest = (value:any) => {
  // 清除定时器 避免快速点击 test now 按钮出现计时器叠加问题
  clearTimeout(testNowTimer)
  // 调用次数
  pullMessageCount++

  // 拉取消息结果处理
  const testNowResultResolve = (result:any) => {
    if (pullMessageCount < 10) {
      console.info(`第${pullMessageCount}次拉取test now 没消息`)
      // 前十次没拉取到消息，继续轮询
      repeatRequestTimer(result)
    } else {
      console.info(`第${pullMessageCount}次拉取test now，没消息，发起超时请求`)
      // 调用对话接口发起超时请求
      apiGetDialogChat(result.timeoutParams).then((res: any) => {
        register(res.data.data)
      })
    }
  }
  // 拉取test now检测结果
  apiGetDialogPullMessageTestNow(value.pullParams).then((result: any) => {
    // 如果有消息
    console.info(`第${pullMessageCount}次拉取test now，有消息，展示话术、清除短轮询定时器`)
    clearTimeout(testNowTimer)
    register(result.data.data)
  }).catch((error: any) => {
    // 请求失败继续轮询
    testNowResultResolve(value)
    // 抛出异常
    console.error(error)
  })
}

